import React from 'react';
import { getClassName } from '@onsolve/utils.get-class-name';
import styles from './SuccessToast.module.scss';
import { t } from '@lingui/macro';
const SuccessToast = ({ setShowSuccessToast }) => {
    const [rootClass, getChildClass] = getClassName({
        rootClass: 'responseOptionSuccess-page',
        styles,
    });
    return (<div className={`${rootClass}`}>
            <div className={getChildClass('successToastr')}>
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="48" height="48" fill="#DEF2C5"/>
                    <g clipPath="url(#clip0_427_1081)">
                        <path fillRule="evenodd" clipRule="evenodd" d="M28.4159 18.3759C28.7605 18.6057 28.8536 19.0713 28.6239 19.416L21.9766 29.3869C21.5275 30.0606 20.5662 30.1361 20.0174 29.5407L17.2224 26.5083C16.9417 26.2037 16.9611 25.7292 17.2656 25.4485C17.5702 25.1677 18.0447 25.1871 18.3254 25.4917L20.9049 28.2903L27.3758 18.5839C27.6056 18.2393 28.0712 18.1462 28.4159 18.3759Z" fill="#4F7000"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_427_1081">
                            <rect width="16" height="16" fill="white" transform="translate(15 16)"/>
                        </clipPath>
                    </defs>
                </svg>
            </div>

            <div className={getChildClass('successToastrMessage')}>
                <p>{t `Your response has been accepted. Thank you!`}</p>
            </div>
            <div className={getChildClass('successToastrCloseBtn')}>
                <svg onClick={() => setShowSuccessToast(false)} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.7 1.3C14.3 0.9 13.7 0.9 13.3 1.3L8 6.6L2.7 1.3C2.3 0.9 1.7 0.9 1.3 1.3C0.9 1.7 0.9 2.3 1.3 2.7L6.6 8L1.3 13.3C0.9 13.7 0.9 14.3 1.3 14.7C1.5 14.9 1.7 15 2 15C2.3 15 2.5 14.9 2.7 14.7L8 9.4L13.3 14.7C13.5 14.9 13.8 15 14 15C14.2 15 14.5 14.9 14.7 14.7C15.1 14.3 15.1 13.7 14.7 13.3L9.4 8L14.7 2.7C15.1 2.3 15.1 1.7 14.7 1.3Z" fill="#4F7000"/>
                    <mask id="mask0_427_1087" maskUnits="userSpaceOnUse" x="1" y="1" width="14" height="14">
                        <path d="M14.7 1.3C14.3 0.9 13.7 0.9 13.3 1.3L8 6.6L2.7 1.3C2.3 0.9 1.7 0.9 1.3 1.3C0.9 1.7 0.9 2.3 1.3 2.7L6.6 8L1.3 13.3C0.9 13.7 0.9 14.3 1.3 14.7C1.5 14.9 1.7 15 2 15C2.3 15 2.5 14.9 2.7 14.7L8 9.4L13.3 14.7C13.5 14.9 13.8 15 14 15C14.2 15 14.5 14.9 14.7 14.7C15.1 14.3 15.1 13.7 14.7 13.3L9.4 8L14.7 2.7C15.1 2.3 15.1 1.7 14.7 1.3Z" fill="white"/>
                    </mask>
                    <g mask="url(#mask0_427_1087)">
                        <rect width="16" height="16" fill="#4F7000"/>
                        <mask id="mask1_427_1087" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                            <rect width="16" height="16" fill="white"/>
                        </mask>
                        <g mask="url(#mask1_427_1087)"></g>
                    </g>
                </svg>
            </div>
        </div>);
};
export default SuccessToast;
